import React from 'react'
import styled from 'styled-components'

const Div = styled.div`
  margin: ${props => props.margin || '4rem 0 2rem 0'};
  font-size: 7rem;
  text-align: center;
  line-height: 7.5rem;

  & > div {
    margin-bottom: 4rem;
  }

  & > div:last-child {
    margin-bottom: 0;
  }

  & img {
    height: 5rem;
  }

  @media (max-width: 1024px) {
    font-size: 5rem;
    line-height: 5.1rem;

    & img {
      height: 3.5rem;
    }
  }

  @media (max-width: 480px) {
    font-size: 3.5rem;
    line-height: 3.8rem;

    & img {
      display: none;
    }
  }
`

const Text = (props) => (
  <Div {...props}>
    {props.children}
  </Div>
)

export default Text



// WEBPACK FOOTER //
// ./src/components/Text.js